import Vue from 'vue';
import Vuex from 'vuex';
import session from '@demre/client-common/src/components/jwt-refresher/session';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    username: null,
    local: null,
    nominaPersonal: [],
    funciones: [],
    situacionesEmergentes: [],
    situacionesPreguntas: [],
    formasPruebas: {},
    updateSituacionesEmergentes: false,
    updateObservacionesPostulante: false,
    tipoEvaluaciones: [],
    vigenciaSede: null,
    bancos: [],
    estadoConfirmar: null,
    diasRendicion: {},
    tiposObservacionesLocal: [],
    tiposSitEmergentesExam: [],
    pruebas: {},
    paises: [],
    consultor: false,
  },
  actions,
  mutations,
  getters,
  modules: {
    session,
  }
});
